// removed by extract-text-webpack-plugin
module.exports = {"Page":"_2U_4h0gAQKGtIjxQ4UjyEq"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Timesheets/index.css
// module id = 871
// module chunks = 0